import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const FaixaEmail = styled.div<{ variacao: 'sucesso' | 'erro' | 'espera' }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 8px;
  margin-bottom: 22px;
  background: ${({ variacao }) =>
    variacao === 'sucesso'
      ? Cores.SUCESSO_FUNDO
      : variacao === 'erro'
      ? Cores.PERIGO_ERRO_FUNDO
      : Cores.ATENCAO_FUNDO};

  strong {
    display: block;
    color: ${({ variacao }) =>
      variacao === 'sucesso'
        ? Cores.SUCESSO_ESCURO
        : variacao === 'erro'
        ? Cores.PERIGO_ERRO_ESCURO
        : Cores.ATENCAO_ESCURO};
  }

  span {
    font-size: 14px;
    color: ${({ variacao }) =>
      variacao === 'sucesso'
        ? Cores.SUCESSO
        : variacao === 'erro'
        ? Cores.PERIGO_ERRO
        : Cores.ATENCAO_ESCURO};
  }
`

export const CabecalhoDetalhe = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`

export const StatusPill = styled.span<{
  variacao: 'aberto' | 'finalizado' | 'cancelado'
}>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  background: ${({ variacao }) =>
    variacao === 'finalizado'
      ? Cores.SUCESSO_FUNDO
      : variacao === 'cancelado'
      ? Cores.PERIGO_ERRO_FUNDO
      : Cores.ATENCAO_FUNDO};
  color: ${({ variacao }) =>
    variacao === 'finalizado'
      ? Cores.SUCESSO_ESCURO
      : variacao === 'cancelado'
      ? Cores.PERIGO_ERRO_ESCURO
      : Cores.ATENCAO_ESCURO};
`

export const CabecalhoEndereco = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
`

export const AcoesFinalizar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`
